import { useSelector } from 'react-redux'
import { WaterTestStripSelector } from '../../../store/waterTestStrip'
import { AnalysisError, SuccessfulAnalysis, EmptyResults } from './subComponents'

export const Results = () => {
  const status = useSelector(WaterTestStripSelector.selectWaterTestStripStatus)
  const error = useSelector(WaterTestStripSelector.error)
  const result = useSelector(WaterTestStripSelector.selectWaterTestStripResult)

  if (error || status === 'failed') {
    return <AnalysisError />
  }

  if (!result) {
    return <EmptyResults />
  }

  return <SuccessfulAnalysis />
}